<template>
  <div id="pShop">
    <Nav type="transparent" />
    <span class="pageTitle">精品店信息</span>
    <div class="pContent" style="padding-bottom: 140px;">
      <div class="block">
        <div class="blockTit">凤凰汇甄选店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo5.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map9"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map10')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 朝阳区 左家庄街道 凤凰汇购物中心2层L217
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:13260374723">13260374723</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">三里屯店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo1.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map1"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map4')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 朝阳区 工体北路8号院三里屯SOHO5号 商场B1层B1-518
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:010-59359220">010-59359220</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">阜成门店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo6.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map2"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map5')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 西城区 西直门南小街西派国际 3号公寓底商101
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:010-66494066">010-66494066</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">远洋国际中心店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo3.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map3"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map6')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 朝阳区 慈云寺远洋国际中心C座底商107（711便利店）旁
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:15011343283">15011343283</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">望京店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo4.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map7"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map8')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 朝阳区 望京soho 塔2商业A区6层2610
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:010-84245231">010-84245231</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">华熙店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo7.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map11"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map12')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 海淀区 万寿路街道西翠路华熙LIVE冰上中心B1-108（南侧户外）
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:16710862107">16710862107</a>
        </div>
      </div>
      <div class="block">
        <div class="blockTit">泛海国际店</div>
        <div class="shop-photo clearfix">
          <div class="item"><img src="../assets/shop-photo8.jpg" alt="" /></div>
          <div class="item bmap">
            <div id="map13"></div>
            <img src="../assets/map-icon.png" alt="" @click="showInfo('map14')" />
          </div>
        </div>
        <div class="blockText">
          店面地址：北京市 朝阳区 东风乡星火西路19号楼泛海国际底商二层205
        </div>
        <div class="blockText">
          营业时间：AM 11:00-PM 21:00（最晚预约时间19:30）
        </div>
        <div class="blockText">
          预约电话：<a href="tel:16710859827">16710859827</a>
        </div>
      </div>
    </div>
    <mu-dialog title="" width="826" class="mapInfo" :open.sync="dialog">
      <div class="mapContent" v-if="mapName == 'map4'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>三里屯店</h2>
        <p>店面地址：北京市 朝阳区 工体北路8号院三里屯SOHO5号 商场B1层B1-518</p>
        <div id="map4"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map5'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>阜成门店</h2>
        <p>店面地址：北京市 西城区 西直门南小街西派国际3号公寓底商101</p>
        <div id="map5"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map6'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>远洋国际中心店</h2>
        <p>
          店面地址：北京市 朝阳区 慈云寺远洋国际中心C座底商107（711便利店）旁
        </p>
        <div id="map6"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map8'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>望京店</h2>
        <p>店面地址：北京市 朝阳区 望京soho 塔2商业A区6层2610</p>
        <div id="map8"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map10'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>凤凰汇甄选店</h2>
        <p>店面地址：北京市 朝阳区 左家庄街道 凤凰汇购物中心2层L217</p>
        <div id="map10"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map12'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>凤凰汇甄选店</h2>
        <p>店面地址：北京市 朝阳区 左家庄街道 凤凰汇购物中心2层L217</p>
        <div id="map12"></div>
      </div>
      <div class="mapContent" v-if="mapName == 'map14'">
        <img src="../assets/close.png" alt="" class="close" @click="dialog = false" />
        <h2>凤凰汇甄选店</h2>
        <p>店面地址：北京市 朝阳区 左家庄街道 凤凰汇购物中心2层L217</p>
        <div id="map14"></div>
      </div>
    </mu-dialog>
    <ToTop />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import ToTop from '@/components/ToTop.vue';
let maps = {};
export default {
  name: 'pShop',
  data() {
    return {
      dialog: false,
      mapName: '',
    };
  },
  components: {
    Nav,
    ToTop,
  },
  computed: {},
  methods: {
    openDialog() {
      // this.dialog = true;
    },
    createMap(name, x, y) {
      var map = new BMap.Map(name);
      var point = new BMap.Point(x, y);
      map.centerAndZoom(point, 15);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker);
      var top_right_navigation = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_SMALL,
      });
      map.addControl(top_right_navigation);
    },
    showInfo(name) {
      this.dialog = true;
      this.mapName = name;
      setTimeout(() => {
        if (name == 'map4') {
          this.createMap('map4', 116.460786, 39.937504);
        } else if (name == 'map5') {
          this.createMap('map5', 116.364762, 39.936733);
        } else if (name == 'map6') {
          this.createMap('map6', 116.497775, 39.918381);
        } else if (name == 'map10') {
          this.createMap('map10', 116.463829, 39.968421);
        } else if (name == 'map12') {
          this.createMap('map12', 116.288985, 39.915306);
        } else if (name == 'map14') {
          this.createMap('map14', 116.507769, 39.943641);
        } else {
          this.createMap('map8', 116.486709, 40.002955);
        }
      }, 200);
    },
  },
  mounted() {
    this.createMap('map1', 116.460786, 39.937504);
    this.createMap('map2', 116.364762, 39.936733);
    this.createMap('map3', 116.497775, 39.918381);
    this.createMap('map7', 116.486709, 40.002955);
    this.createMap('map9', 116.463829, 39.968421);
    this.createMap('map11', 116.288985, 39.915306);
    this.createMap('map13', 116.507769, 39.943641);
  },
};
</script>

<style lang="scss" scoped>
#pShop {
  padding: 350px 0 40px;
  background: url(../assets/pShop-banner.jpg) top/auto 350px no-repeat;

  .pContent {
    margin: 0 auto;
    // width: 1200px;
    // @media(width: 1024px){
    //     width: 980px;
    // }
    width: 90%;
    max-width: 1200px;
  }
  .blockTit {
    margin: 90px 0 48px;
  }
  .blockText {
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .shop-photo {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: 24px;

    .item {
      flex: 1;
      margin: 0 5px;

      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }

      > img {
        display: block;
        width: 100%;
      }
    }
    .bmap {
      position: relative;
      > div {
        height: 100%;
      }
      > img {
        position: absolute;
        left: 0;
        top: 0;
        width: 13.47%;
        opacity: 0.8;
        z-index: 800;
        cursor: pointer;
        pointer-events: auto;
        transition: all 0.3s;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
.mapInfo {
  .mapContent {
    position: relative;
  }
  h2 {
    font-size: 24px;
    line-height: 1;
    color: #333;
  }
  p {
    margin: 16px 0 20px;
    font-size: 14px;
    line-height: 1;
    color: #313131;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 900;
    pointer-events: auto;
  }
}
#map4,
#map5,
#map6,
#map8,
#map10,
#map12,
#map14 {
  height: 350px;
}
</style>
